// Auth Types
export const LOGIN = "LOGIN";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";
export const LOGOUT = "LOGOUT";
export const CLEAR_AUTH_ERROR = "CLEAR_AUTH_ERROR";
export const SET_MODULE_GRANTS = "SET_MODULE_GRANTS";

// Team Management Types
export const ADD_CLUSTER="ADD_CLUSTER";
export const ADD_CLINIC="ADD_CLINIC";
export const ADD_PRACTITIONER="ADD_PRACTITIONER";
export const GET_ALL_CLUSTER="GET_ALL_CLUSTER";
export const GET_CLUSTER_BY_ID="GET_CLUSTER_BY_ID";
export const UPDATE_CLUSTER_BY_ID="UPDATE_CLUSTER_BY_ID";
export const UPDATE_CLINIC_BY_ID="UPDATE_CLINIC_BY_ID";
export const UPDATE_PRACTITIONER_BY_ID="UPDATE_PRACTITIONER_BY_ID";
export const GET_ALL_CLINIC="GET_ALL_CLINIC";
export const GET_CLINIC_BY_ID="GET_CLINIC_BY_ID";
export const GET_PRACTITIONER_BY_ID="GET_PRACTITIONER_BY_ID";
export const GET_ALL_PRACTITIONER="GET_ALL_PRACTITIONER";
export const GET_ROLES="GET_ROLES";
export const SET_ROLES="SET_ROLES";
export const MODIFY_STATUS_CLUSTER="MODIFY_STATUS_CLUSTER";
export const MODIFY_STATUS_CLINIC="MODIFY_STATUS_CLINIC";
export const MODIFY_STATUS_PRACTITIONER="MODIFY_STATUS_PRACTITIONER";
export const GET_FULL_PROFILE="GET_FULL_PROFILE"
export const UPDATE_FULL_PROFILE="UPDATE_FULL_PROFILE"
export const GET_PROGRESS_SUMMARY="GET_PROGRESS_SUMMARY"
export const GET_PROGRESS_HISTORY="GET_PROGRESS_HISTORY"
export const UPDATE_PROGRESS_ENTRY="UPDATE_PROGRESS_ENTRY"
export const DELETE_PROGRESS_ENTRY="DELETE_PROGRESS_ENTRY"
export const GET_MEDICAL_HISTORY="GET_MEDICAL_HISTORY"
export const UPDATE_MEDICAL_HISTORY="UPDATE_MEDICAL_HISTORY"
export const GET_REPORTS="GET_REPORTS"
export const DELETE_REPORT="DELETE_REPORT"
export const GET_FOOD_LIFESTYLE="GET_FOOD_LIFESTYLE"
export const UPDATE_FOOD_LIFESTYLE="UPDATE_FOOD_LIFESTYLE"
export const GET_RECALL="GET_RECALL"
export const UPDATE_RECALL="UPDATE_RECALL"
export const GET_ACTIVITY_BY_DATE="GET_ACTIVITY_BY_DATE"
export const SET_ACTIVITY_GOAL="SET_ACTIVITY_GOAL"
export const GET_FIRST_LAST_MEASURE="GET_FIRST_LAST_MEASURE"
export const GET_ALL_MEASURES="GET_ALL_MEASURES"
export const DELETE_MEASURE_BY_ID="DELETE_MEASURE_BY_ID"
export const GET_BODY_STARTED_CURRENT="GET_BODY_STARTED_CURRENT"
export const GET_ALL_BODY_MEASURES="GET_ALL_BODY_MEASURES"
export const DELETE_BODY_MEASURE_BY_ID="DELETE_BODY_MEASURE_BY_ID"
export const GET_ALL_LEADS="GET_ALL_LEADS"
export const GET_ALL_CUSTOMERS="GET_ALL_CUSTOMERS"
export const GET_CLUSTERS="GET_CLUSTERS"
export const GET_PRACTITIONERS="GET_PRACTITIONERS"
export const GET_CLINICS="GET_CLINICS"
export const GET_TAGS="GET_TAGS"
export const GET_COUNTRIES="GET_COUNTRIES"
export const GET_STATES="GET_STATES"
export const GET_CITIES="GET_CITIES"
export const GET_CUISINES="GET_CUISINES"
export const GET_DIET="GET_DIET"
export const UPLOAD_PROGRAM_IMAGE="UPLOAD_PROGRAM_IMAGE"
export const UPLOAD_IMAGE="UPLOAD_IMAGE"
export const CREATE_PROGRAM="CREATE_PROGRAM"
export const GET_PROGRAM_ENROLLED_USERS = "GET_PROGRAM_ENROLLED_USERS";
export const GET_SESSION_BOOKED_USERS = "GET_SESSION_BOOKED_USERS";
export const GET_CUSTOMER_FOOD_LOGS = "GET_CUSTOMER_FOOD_LOGS";
export const GET_CUSTOMER_HISTORY = "GET_CUSTOMER_HISTORY";
export const GET_PROGRAM_RECORDED_VIDEOS = "GET_PROGRAM_RECORDED_VIDEOS";
export const SAVE_PROGRAM_RECORDED_VIDEOS = "SAVE_PROGRAM_RECORDED_VIDEOS";
export const DELETE_PROGRAM_RECORDED_VIDEO = "DELETE_PROGRAM_RECORDED_VIDEO";
export const GET_CLINICS_FOR_PROGRAM="GET_CLINICS_FOR_PROGRAM"
export const GET_ALL_PROGRAMS="GET_ALL_PROGRAMS"
export const GET_PROGRAM_BY_ID="GET_PROGRAM_BY_ID"
export const UPDATE_PROGRAM_BY_ID="UPDATE_PROGRAM_BY_ID"
// Company Calendar
export const GET_ALL_PUBLISHED_PROGRAMS="GET_ALL_PUBLISHED_PROGRAMS"
export const GET_PROGRAMS_BY_MONTH="GET_PROGRAMS_BY_MONTH"
export const SET_AVAIL_DATE="SET_AVAIL_DATE"
export const SET_BLOCK_DATE="SET_BLOCK_DATE"
// Holidays
export const GET_HOLIDAYS_BY_MONTH="GET_HOLIDAYS_BY_MONTH"
export const ADD_HOLIDAY="ADD_HOLIDAY"
export const REMOVE_HOLIDAY="REMOVE_HOLIDAY"
// Sessions
export const UPLOAD_SESSION_IMAGE="UPLOAD_SESSION_IMAGE"
export const CREATE_SESSION="CREATE_SESSION"
export const GET_ALL_SESSIONS="GET_ALL_SESSIONS"
export const GET_SESSION_BY_ID="GET_SESSION_BY_ID"
export const UPDATE_SESSION="UPDATE_SESSION"
export const CREATE_MEALS_CONFIGURATION="CREATE_MEALS_CONFIGURATION"
export const UPLOAD_MEALS_IMAGE="UPLOAD_MEALS_IMAGE"
export const GET_MEALS_USER="GET_MEALS_USER"
export const GET_MEALS_USER_BY_ID="GET_MEALS_USER_BY_ID"
export const UPDATE_MEAL_CONFIGURATION_BY_ID="UPDATE_MEAL_CONFIGURATION_BY_ID"
// Menu Items
export const UPLOAD_MENU_ITEM_IMAGE="UPLOAD_MENU_ITEM_IMAGE"
export const CREATE_MENU_ITEM="CREATE_MENU_ITEM"
export const GET_MENU_ITEM_BY_ID="GET_MENU_ITEM_BY_ID"
export const UPDATE_MENU_ITEM_BY_ID="UPDATE_MENU_ITEM_BY_ID"
// ABHA
export const CHECK_ABHA_EXISTS="CHECK_ABHA_EXISTS"
export const VERIFY_ABHA_PHONE="VERIFY_ABHA_PHONE"
// Carousel
export const GET_CAROUSEL_URLS="GET_CAROUSEL_URLS"
export const UPLOAD_CAROUSEL_IMAGE="UPLOAD_CAROUSEL_IMAGE"
export const DELETE_CAROUSEL_IMAGE="DELETE_CAROUSEL_IMAGE"
// Social Links
export const GET_SOCIAL_LINKS="GET_SOCIAL_LINKS"
export const GET_ABOUT_US = "GET_ABOUT_US";
export const SET_ABOUT_US = "SET_ABOUT_US";
export const DELETE_CUSTOMER_ACCOUNT = "DELETE_CUSTOMER_ACCOUNT";
export const DELETE_USER_ACCOUNT = "DELETE_USER_ACCOUNT";
export const UPLOAD_ABOUT_US_IMAGE = "UPLOAD_ABOUT_US_IMAGE";
export const SET_SOCIAL_LINKS="SET_SOCIAL_LINKS"
// Diet Compliance
export const GET_DIET_COMPLIANCE="GET_DIET_COMPLIANCE"
export const GET_DIET_PLAN_CONFIG = "GET_DIET_PLAN_CONFIG";
export const SET_DIET_PLAN_START_DATE = "SET_DIET_PLAN_START_DATE";
export const SET_DIET_COMPLIANCE="SET_DIET_COMPLIANCE"
export const GET_BOOKED_SESSIONS_BY_DATE="GET_BOOKED_SESSIONS_BY_DATE"
export const CHANGE_SESSION_STATUS="CHANGE_SESSION_STATUS"
export const VERIFY_ABHA_OTP="VERIFY_ABHA_OTP"
export const ADD_ABHA="ADD_ABHA"
export const GET_ALL_ABHA_CUSTOMERS="GET_ALL_ABHA_CUSTOMERS"
export const LINK_ABHA_DOCUMENT="LINK_ABHA_DOCUMENT"
export const GET_ITEM_CATEGORIES="GET_ITEM_CATEGORIES"
export const EDIT_CATEGORY="EDIT_CATEGORY"
export const CREATE_CATEGORY="CREATE_CATEGORY"
export const GET_ITEM_PRODUCTS="GET_ITEM_PRODUCTS"
export const GET_PRODUCT_BY_ID="GET_PRODUCT_BY_ID"
export const CREATE_CUSTOMER="CREATE_CUSTOMER"
export const CONVERT_TO_LEAD="CONVERT_TO_LEAD"
// Meal Management
export const GET_MEAL_OPTIONS="GET_MEAL_OPTIONS"
export const GET_MEAL_MANAGEMENT_ORDERS="GET_MEAL_MANAGEMENT_ORDERS"
// Guidelines
export const GET_GUIDELINES="GET_GUIDELINES"
export const SET_OR_UPDATE_GUIDELINES="SET_OR_UPDATE_GUIDELINES"
// Booked Sessions by Customer
export const GET_BOOKED_SESSIONS_BY_CUSTOMER="GET_BOOKED_SESSIONS_BY_CUSTOMER"
// Health Feed
export const CREATE_HEALTH_FEED="CREATE_HEALTH_FEED"
export const GET_ALL_HEALTH_FEED="GET_ALL_HEALTH_FEED"
export const GET_HEALTH_FEED_BY_ID="GET_HEALTH_FEED_BY_ID"
export const DELETE_HEALTH_FEED="DELETE_HEALTH_FEED"
export const UPDATE_HEALTH_FEED="UPDATE_HEALTH_FEED"
// Enrollments
export const GET_LIST_OF_ENROLLMENTS="GET_LIST_OF_ENROLLMENTS"
export const GET_ENROLLMENT_RESPONSE="GET_ENROLLMENT_RESPONSE"
export const GET_PROMOS="GET_PROMOS"
export const GET_ALL_DIET_COMPLIANCE="GET_ALL_DIET_COMPLIANCE"
// Documents
export const GET_DOCUMENTS="GET_DOCUMENTS"
export const SET_DOCUMENT="SET_DOCUMENT"
export const UPDATE_DOCUMENT="UPDATE_DOCUMENT"
export const DELETE_DOCUMENT="DELETE_DOCUMENT"
export const GET_CUSTOMER_PAYMENTS="GET_CUSTOMER_PAYMENTS"
// Standalone video library (/videos/*), separate from health feeds.
export const GET_ALL_VIDEOS="GET_ALL_VIDEOS"
export const CREATE_VIDEO="CREATE_VIDEO"
export const UPDATE_VIDEO="UPDATE_VIDEO"
export const DELETE_VIDEO="DELETE_VIDEO"
